import React, { useState, useEffect } from "react";
import { Table, Button, Popconfirm, message, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const AppointmentList = ({ onStatusUpdate }) => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppointments = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/api/appointments`);
        const sortedAppointments = response.data.sort((a, b) => {
          if (a.status === "pending") return -1;
          return 1;
        });
        setAppointments(sortedAppointments);
      } catch (error) {
        console.error("Randevular alınırken hata:", error);
        message.error("Randevular alınamadı.");
      } finally {
        setLoading(false);
      }
    };
    fetchAppointments();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/api/appointments/${id}`);
      setAppointments(appointments.filter((app) => app.id !== id));
      message.success("Randevu silindi.");
      onStatusUpdate(); // Durum güncellenince admin sayfasındaki bildirimleri yenile
    } catch (error) {
      console.error("Randevu silinirken hata:", error);
      message.error("Randevu silinemedi.");
    }
  };

  const columns = [
    {
      title: "Ad Soyad",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Telefon",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Tarih",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Saat",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Durum",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color = status === "approved" ? "green" : status === "rejected" ? "volcano" : "orange";
        const label = status === "approved" ? "Onaylı" : status === "rejected" ? "Reddedildi" : "Bekliyor";
        return <Tag color={color}>{label}</Tag>;
      },
    },
    {
      title: "İşlemler",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            onClick={() => navigate(`/admin/appointments/${record.id}`)}
          >
            Detay
          </Button>
          <Popconfirm
            title="Bu randevuyu silmek istediğinize emin misiniz?"
            onConfirm={() => handleDelete(record.id)}
            okText="Evet"
            cancelText="Hayır"
          >
            <Button type="link" danger>
              Sil
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Randevular</h2>
      <Table
        columns={columns}
        dataSource={appointments}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};

export default AppointmentList;
